import React, { memo } from 'react'

// Libraries
import { Col, Container, Navbar, Row, Button } from 'react-bootstrap'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { m } from 'framer-motion'
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom";


// Components
const InteractiveBannersData02 = [
    {
        subtitle: "See Real Professional History",
        title: "Get access to verified ratings and reviews from past employers, peers, and clients—no guesswork.",
        img: "https://lithoreact.themezaa.com/assets/img/webp/home-business-services-img02.webp",
         btnTitle: "Learn more",
        btnLink: "/page/about-us"
        
    },
    {
        subtitle: "Instant Profile Verification",
        title: "Verify candidates’ job history, skills, and behavior in just one click, saving time and reducing errors.",
        img: "https://lithoreact.themezaa.com/assets/img/webp/home-business-services-img02.webp",
         btnTitle: "Learn more",
        btnLink: "/page/about-us"

    },
    {
        subtitle: "Reduce Hiring Fraud",
        title: "Avoid early exits, fake profiles, and resume padding with transparent, data-backed hiring insights.",
        img: "https://lithoreact.themezaa.com/assets/img/webp/home-business-services-img02.webp",
         btnTitle: "Learn more",
        btnLink: "/page/about-us"

    },
    {
        subtitle: "Hire Better, Faster",
        title: "Make confident hiring decisions with AI-powered credibility reports and smart connection tools.",
        img: "https://lithoreact.themezaa.com/assets/img/webp/home-business-services-img02.webp",
         btnTitle: "Learn more",
        btnLink: "/page/about-us"
  
    }
]
// Data
// import { InteractiveBannersData02 } from './InteractiveBannersData'

const InteractiveBanners02 = (props) => {
    const swiperRef = React.useRef(null)
     const navigate = useNavigate();
    const handleReviewClick = () => {
        const jwtTokenJobcritic = localStorage.getItem("jwt_token_jobcritic"); // Check user_id in localStorage
        if (jwtTokenJobcritic) {
            navigate("/employee_detail"); // If logged in, go to review form
        } else {
            navigate("/login"); // If not logged in, go to login
        }
    };
    return (
        <Row className={`interactivebanners-style-02 -mr-[30vw] md:mr-[-15px] sm:contents ${props.className}`}>
            <Swiper className="white-move" modules={[Autoplay, Pagination, Navigation]} {...props.carousalOption} ref={swiperRef} >
                {
                    props.data.map((item, i) => {
                        return (
                            <SwiperSlide key={i} className="my-swiper">
                                <m.div className="interactivebanners-main" {...{ ...props.animation, transition: { delay: i * props.animationDelay } }}>
                                    <div className="relative overflow-hidden overlay-bg">
                                        {item.img && <img height="235" width="210" className="interactiveanners-img" src={item.img} alt="The World’s Only Platform for Individual Ratings and Reviews" />}
                                    </div>
                                    <div className="fancy-text-content px-[55px] xs:px-[30px] xxs:px-[30px]">
                                        {item.subtitle && <span className="interactivebanners-subtitle px-[15px] py-[5px] mb-[20px] rounded-[2px] text-white text-xxs font-serif uppercase leading-4 tracking-[1px] inline-block">{item.subtitle}</span>}
                                        {item.title && <div className="interactivebanners-title mb-[10px] text-white text-xlg font-serif lg:text-[18px]">{item.title}</div>}
                                        {(item.btnTitle && item.btnLink) &&  <Button className="btn-explore-white bto btq" onClick={handleReviewClick} >Try Now</Button>}
                                    </div>
                                </m.div>
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
        </Row>
    )
}

InteractiveBanners02.defaultProps = {
    data: InteractiveBannersData02,
    animationDelay: 0.2
}

InteractiveBanners02.propTypes = {
    className: PropTypes.string,
    animationDelay: PropTypes.number,
    animation: PropTypes.object,
    data: PropTypes.arrayOf(
        PropTypes.exact({
            subtitle: PropTypes.string,
            title: PropTypes.string,
            img: PropTypes.string,
            btnTitle: PropTypes.string,
            btnLink: PropTypes.string,
        })
    )
}

export default memo(InteractiveBanners02)